var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portalFrame"},[_c(_vm.currentFrame,{tag:"component"}),(_vm.isClosed)?_c('div',{staticClass:"mantle_div"},[_c('p',[_vm._v("暂停访问")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }